import { Card, Heading, Text } from '@chakra-ui/react';
import type { IconProps } from '@chakra-ui/react';
import { ElementType, FC } from 'react';

interface IBenefitCardProps {
  Icon: ElementType<IconProps>;
  heading: string;
  description: string;
}

const BenefitCard: FC<IBenefitCardProps> = ({ Icon, heading, description }) => {
  return (
    <Card
      borderWidth='2px'
      gap='sm'
      p='md'
      variant='outline'
      w={{ base: '100%', md: '45%', lg: '30%' }}
    >
      <Icon
        boxSize={8}
        color='icon.dark'
        strokeWidth='1.5'
      />
      <Heading
        as='h3'
        size='md'
      >
        {heading}
      </Heading>
      <Text
        color='text.medium'
        fontSize='lg'
      >
        {description}
      </Text>
    </Card>
  );
};

export default BenefitCard;
